module.exports = __webpack_public_path__ + "static/media/businessinsider__stefanie-williams-response-to-yelp-employee-talia-jane-2016-2_plot.9cd8af4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/businessinsider__stefanie-williams-response-to-yelp-employee-talia-jane-2016-2_plot.png
// module id = 366
// module chunks = 0